import { useRef } from 'react';
import _isEqual from 'lodash.isequal';

// Compares a value using lodash isequal
function useDeepCompare<T>(value: T): T {
  // Box the last value
  const ref = useRef<T>();

  if (typeof ref.current == 'undefined' || !_isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
}

export default useDeepCompare;
